import {
  Settings,
  Users2,
  Users,
  Banknote,
  ShoppingBag,
  FileText,
  Globe,
  Home,
  Mail,
  IdCard,
  Puzzle,
  Receipt,
  CreditCard,
  Landmark,
  KeyRound,
  BellRing,
  Sparkles,
  ScanLine,
  ShieldCheck,
} from 'lucide-react';
import type { StaticEntry } from './types';

export const settingsEntries: StaticEntry[] = [
  { id: 'settings-general', label: 'General', icon: Settings, path: '/settings/general' },
  {
    id: 'settings-public-details',
    label: 'Public details',
    icon: IdCard,
    path: '/settings/public-details',
  },
  {
    id: 'settings-team',
    label: 'Team members',
    icon: Users2,
    path: '/settings/members',
  },
  {
    id: 'settings-payments',
    label: 'Payments',
    icon: CreditCard,
    path: '/settings/payments',
  },
  {
    id: 'settings-abandoned',
    label: 'Cart abandonment',
    icon: ShoppingBag,
    path: '/settings/cart-abandonment',
  },
  {
    id: 'settings-check-in-staff',
    label: 'Check-in staff',
    icon: ScanLine,
    path: '/settings/check-in-staff',
  },
  {
    id: 'settings-checkout-protection',
    label: 'Checkout Protection',
    icon: ShieldCheck,
    path: '/settings/checkout-protection',
  },
  {
    id: 'settings-invoices',
    label: 'Invoices',
    icon: FileText,
    path: '/settings/invoices',
  },
  { id: 'settings-domains', label: 'Domains', icon: Globe, path: '/settings/domains' },
  { id: 'settings-homepage', label: 'Homepage', icon: Home, path: '/settings/homepage' },
  { id: 'settings-email', label: 'Email', icon: Mail, path: '/settings/email' },
  {
    id: 'settings-portal',
    label: 'Customer portal',
    icon: Users,
    path: '/settings/customer-portal',
  },
  {
    id: 'settings-integrations',
    label: 'Integrations',
    icon: Puzzle,
    path: '/settings/integrations',
  },
  {
    id: 'settings-fixed-tax',
    label: 'Fixed tax rates',
    icon: Receipt,
    path: '/settings/tax/fixed-tax-rates',
  },
  {
    id: 'settings-stripe-tax',
    label: 'Stripe Tax',
    icon: Receipt,
    path: '/settings/tax/stripe-tax',
  },
  {
    id: 'settings-tax',
    label: 'Tax behavior',
    icon: Receipt,
    path: '/settings/tax',
  },
  { id: 'settings-plan', label: 'Plan', icon: Sparkles, path: '/settings/plan' },
  { id: 'settings-billing', label: 'Billing', icon: Banknote, path: '/settings/billing' },
  {
    id: 'settings-payouts',
    label: 'Stripe & payouts',
    icon: Landmark,
    path: '/settings/stripe',
  },
  { id: 'settings-api-keys', label: 'API keys', icon: KeyRound, path: '/settings/api' },
  { id: 'settings-webhooks', label: 'Webhooks', icon: BellRing, path: '/settings/webhooks' },
];
